import { useFieldClickTarget } from '../../hooks/useFieldClickTarget';
import { FieldError, Label, RequiredMark, Wrapper } from './FloatingField.styles';
import type { FloatingFieldProps } from './FloatingField.types';

export function FloatingField({
  label,
  hasValue,
  error,
  errorId,
  required = true,
  children,
}: FloatingFieldProps) {
  const { ref, onMouseDown, onClick } = useFieldClickTarget<HTMLDivElement>();

  return (
    <Wrapper ref={ref} onMouseDown={onMouseDown} onClick={onClick}>
      {hasValue && (
        <Label $error={Boolean(error)}>
          {label}
          {required && <RequiredMark>*</RequiredMark>}
        </Label>
      )}
      {children}
      {error && <FieldError id={errorId}>{error}</FieldError>}
    </Wrapper>
  );
}
